import React from 'react';
import PropTypes from 'prop-types';

const PrevArrow = ({ className, onClick }) => (
  <div className={className} onClick={onClick}>
    <svg
      width="14"
      height="23"
      viewBox="0 0 14 23"
      className="tutorium-icon"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 2.68333L11.3514 0L0 11.5L11.3514 23L14 20.3167L5.2973 11.5L14 2.68333Z"
      />
    </svg>
  </div>
);

PrevArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

const NextArrow = ({ className, onClick }) => (
  <div className={className} onClick={onClick}>
    <svg
      width="14"
      height="23"
      viewBox="0 0 14 23"
      className="tutorium-icon"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.34584e-07 20.3167L2.64865 23L14 11.5L2.64865 -9.92367e-07L1.77614e-06 2.68333L8.7027 11.5L2.34584e-07 20.3167Z"
      />
    </svg>
  </div>
);

NextArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

export default {
  Prev: PrevArrow,
  Next: NextArrow,
};
